import SoccerTickerContent from "../sports/SoccerTickerContent";
import BaseballTickerContent from "../sports/BaseballTickerContent";
import AmericanFootballTickerContent from "../sports/AmericanFootballTickerContent";

/** Renderiza los standings según el deporte de la liga (FOOT / BASE / AMFO). */
export default function TickerStandingContent({ standing, sportCode }) {
  if (!standing) return null;

  const sport = String(sportCode || "").toUpperCase();

  if (sport === "BASE") {
    return <BaseballTickerContent standing={standing} renderStandingOnly />;
  }

  if (sport === "AMFO") {
    return <AmericanFootballTickerContent standing={standing} renderStandingOnly />;
  }

  return <SoccerTickerContent standing={standing} renderStandingOnly />;
}
